import { Link as LinkBase } from '@aibees/shared/components/link';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const Link = styled(LinkBase)`
  display: inline-flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${(p) => p.theme.typography.fontWeightSemiBold};
  font-size: ${(p) => p.theme.typography.body2.fontSize};
  color: ${(p) => p.theme.palette.common.black};
  text-decoration: none;
  line-height: 22px;
  &:hover {
    color: ${(p) => p.theme.palette.primary[500]};
    text-decoration: underline;
  }
`;
